import { Stack } from "@mui/material";

import { Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { NewProjectButton } from "Projects/Components/NewProjectButton";
import { ProjectsTable } from "Projects/Components/ProjectsTable";
import { AuthenticatedLayout } from "Shared/Layouts/AuthenticatedLayout";

export const ProjectsPage = (): React.ReactNode => {
  const { t } = useResource();

  return (
    <AuthenticatedLayout
      title={t(Resources.Common.Projects)}
      action={<NewProjectButton />}
    >
      <Stack spacing={Spacing.M}>
        <ProjectsTable />
      </Stack>
    </AuthenticatedLayout>
  );
};
